export const formatDate = (date: Date) => {
  const abbr = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ]
  return `${abbr[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
}

export const formatDateReport = (data: Date) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const days = data.getDate()
  return `${months[data.getMonth()]} ${days}`
}

export const formatDateToLongString = (dateString?: string) => {
  if (dateString) {
    const date = new Date(dateString)

    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    } as const

    return date.toLocaleDateString('en-US', options)
  }
}

export function formatDateToMMDDYYYY(date: Date) {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const year = date.getFullYear()

  return `${month}/${day}/${year}`
}

export const formatDurationToHHMM = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  return hours ? `${hours}h ${minutes}m` : `${minutes}m`
}

export const formatDurationToHHMMSS = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  if (secs !== 0) {
    if (hours > 0) {
      return `${hours}h ${minutes}m ${secs}s`
    } else if (minutes > 0) {
      return `${minutes}m ${secs}s`
    } else {
      return `${secs}s`
    }
  } else {
    if (minutes === 0) {
      return `${hours}h`
    } else {
      return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`
    }
  }
}
